import { render, staticRenderFns } from "./updateCardInfo.vue?vue&type=template&id=671c4bd8&scoped=true"
import script from "./updateCardInfo.vue?vue&type=script&lang=js"
export * from "./updateCardInfo.vue?vue&type=script&lang=js"
import style0 from "./updateCardInfo.vue?vue&type=style&index=0&id=671c4bd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671c4bd8",
  null
  
)

export default component.exports